import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./FirstLoading.scss";
import logo from '../../assets/logo/logo.png'

function Loading() {
  const navigate = useNavigate();
  let timer = 5000;

  useEffect(() => {
    const timerId = setTimeout(() => {
      navigate("/nha-may-dien-mat-troi-dau-tieng-3/tour");
    }, timer);
    return () => {
      clearTimeout(timerId);
    };
  }, [navigate, timer]);

  return (
    <div className="FirstLoading_wrapper">
      <img className="logo_loading" src={logo} alt="logo" />
      {/* Loader 2 */}
      <div className="dot-spinner">
        <div className="dot-spinner__dot"></div>
        <div className="dot-spinner__dot"></div>
        <div className="dot-spinner__dot"></div>
        <div className="dot-spinner__dot"></div>
        <div className="dot-spinner__dot"></div>
        <div className="dot-spinner__dot"></div>
        <div className="dot-spinner__dot"></div>
        <div className="dot-spinner__dot"></div>
      </div>
    </div>
  );
}

export default Loading;
